import { useTranslation } from 'react-i18next';

import { useGetMyProfile } from 'services/hooks/user';
import { useGetBankAccountVerifications, useGetUsersIdentityVerifications } from 'services/hooks/verification';

import Card from 'components/card/Card';
import withErrorBoundary from 'components/provider/withErrorBoundary';

import CreatorInformation from './CreatorInformation';

function CreatorInformationContainer() {
  const { t } = useTranslation();
  const { data: profileData } = useGetMyProfile();
  const { data: identityVerificationData } = useGetUsersIdentityVerifications(profileData?.id);
  const { data: bankAccountVerificationData } = useGetBankAccountVerifications(profileData?.id);
  return (
    <Card isExpanded>
      <Card.Header>
        <Card.Title>{t('chat.rewards_creator_information')}</Card.Title>
      </Card.Header>
      <Card.Body>
        <CreatorInformation
          profileData={profileData}
          identityData={identityVerificationData}
          bankAccountData={bankAccountVerificationData}
        />
      </Card.Body>
    </Card>
  );
}

export default withErrorBoundary(CreatorInformationContainer);
